export const transformDateString = (input: string): string => {
	return `${input.substring(6, 8)}/${input.substring(4, 6)}/${input.substring(
		0,
		4
	)}`;
};
